import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { noopVoid } from 'reactApp/utils/helpers';

export const renderPollPopup = ({ onClose = noopVoid, isPhone = false }) =>
    openPopupHelper({ popupName: popupNames.POLL_DIALOG, data: { isPhone }, onClose });
